import { render, staticRenderFns } from "./PlanItems.vue?vue&type=template&id=367f258e&"
import script from "./PlanItems.vue?vue&type=script&lang=js&"
export * from "./PlanItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports